import { API_URL } from '../../../../utils/config';

// eslint-disable-next-line import/prefer-default-export
export const CREATE_REQUEST_URL = `${API_URL}/adminRequest/category`;
export const GET_STAFF_IN_ADMIN_DEPARTMENT_URL = `${API_URL}/department/employees`;
export const FILTER_REQUESTS_URL = `${API_URL}/adminRequest/filter`;
export const GET_REQUESTS_URL = `${API_URL}/adminRequest`;
export const UPDATE_REQUEST_URL = `${API_URL}/adminRequest`;
